export default "__VITE_ASSET__ff32cff1__"